import { Switch } from '@headlessui/react';
import moment from 'moment';

export default function KinesisEventManagementEditTableRow({ 
    originalKinesisEvent,
    editableKinesisEvent,
    eventTypeOptions,
    eventTerrainOptions,
    eventDistanceOptions,
    onEventDataEdit
}) {

    const hasEventPriorityChange = originalKinesisEvent.eventType !== editableKinesisEvent.eventType;
    const hasEventNameChange = originalKinesisEvent.name !== editableKinesisEvent.name;
    const hasEventTerrainChange = originalKinesisEvent.eventTerrain !== editableKinesisEvent.eventTerrain;
    const hasEventTerrainTextInputChange = originalKinesisEvent.eventTerrainTextInput !== editableKinesisEvent.eventTerrainTextInput;
    const hasEventDistanceChange = originalKinesisEvent.eventDistance !== editableKinesisEvent.eventDistance;
    const hasEventDistanceTextInputChange = originalKinesisEvent.eventDistanceTextInput !== editableKinesisEvent.eventDistanceTextInput;
    const hasEventTrainingStartDateChange = originalKinesisEvent.eventTrainingStartDate !== editableKinesisEvent.eventTrainingStartDate;
    const hasEventDateChange = originalKinesisEvent.eventDate !== editableKinesisEvent.eventDate;
    const hasDeloadAfterEventChange = originalKinesisEvent.deloadAfterEvent !== editableKinesisEvent.deloadAfterEvent;
    const hasArchivedChange = originalKinesisEvent.archived !== editableKinesisEvent.archived;

    const HandleEventDataEdit = (propertyName, value) => {
        onEventDataEdit(editableKinesisEvent.id, propertyName, value)
    }

    return (
        <div className='grid grid-cols-13 divide-x divide-gray-400'>

            {/* Event Priority */}
            <div className='col-span-1'>
                <div 
                    className={`
                        h-full flex items-center gap-x-1
                        ${hasEventPriorityChange ? 'bg-orange-100' : ''}
                    `}
                >
                    <div>
                        <div className='ml-2 w-6 h-6 border border-gray-400 bg-white rounded-full flex items-center justify-center text-xs'>
                            {editableKinesisEvent.eventType === 'a-race' ? 'A' : ''}
                            {editableKinesisEvent.eventType === 'b-race' ? 'B' : ''}
                            {editableKinesisEvent.eventType === 'c-race' ? 'C' : ''}
                        </div>
                    </div>

                    <select
                        className={
                            `w-full py-2 focus:outline-none border-r-[8px] cursor-pointer 
                            ${hasEventPriorityChange ? 'bg-orange-100 border-orange-100' : 'border-white bg-white'}`
                        }
                        value={editableKinesisEvent.eventType}
                        onChange={(e) => HandleEventDataEdit('eventType', e.target.value)}
                    >
                        {eventTypeOptions.map(option => (
                            <option key={option} value={option}>
                                {option.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Event Name */}
            <div className='col-span-2'>
                <input
                    type="text"
                    className={`
                        h-full w-full  p-2 placeholder:text-gray-400 focus:outline-none
                        ${hasEventNameChange ? 'bg-orange-100' : ''}
                    `}
                    placeholder='Enter event name here'
                    value={editableKinesisEvent.name}
                    onChange={(e) => HandleEventDataEdit('name', e.target.value)}
                />
            </div>

            {/* Event Terrain */}
            <div className='col-span-1'>
                <select
                    className={`
                        h-full w-full pl-2 py-2 focus:outline-none border-r-[8px] cursor-pointer
                        ${hasEventTerrainChange ? 'bg-orange-100 border-orange-100' : 'border-white bg-white'}
                    `}
                    value={editableKinesisEvent.eventTerrain}
                    onChange={(e) => HandleEventDataEdit('eventTerrain', e.target.value)}
                >
                    {eventTerrainOptions.map(option => (
                        <option key={option.key} value={option.key}>
                            {option.title}
                        </option>
                    ))}
                </select>
            </div>

            {/* Custom Event Terrain */}
            <div className='col-span-1'>
                {editableKinesisEvent.eventTerrain === 'other' && (
                    <input
                        type="text"
                        className={`
                            h-full w-full p-2 placeholder:text-gray-400 focus:outline-none
                            ${hasEventTerrainTextInputChange ? 'bg-orange-100' : ''}
                        `}
                        placeholder='Enter text'
                        value={editableKinesisEvent.eventTerrainTextInput}
                        onChange={(e) => HandleEventDataEdit('eventTerrainTextInput', e.target.value)}
                    />
                )}

                {editableKinesisEvent.eventTerrain !== 'other' && (
                    <div className="h-full px-2 py-2 bg-white text-gray-500 cursor-not-allowed">
                        N/A
                    </div>  
                )}
            </div>

            {/* Event Distance */}
            <div className='col-span-1'>
                <select
                    className={`
                        h-full w-full pl-2 py-2 focus:outline-none border-r-[8px] cursor-pointer
                        ${hasEventDistanceChange ? 'bg-orange-100 border-orange-100' : 'border-white bg-white'}
                    `}
                    value={editableKinesisEvent.eventDistance}
                    onChange={(e) => HandleEventDataEdit('eventDistance', e.target.value)}
                >
                    {eventDistanceOptions.map(option => (
                        <option key={option.key} value={option.key}>
                            {option.title}
                        </option>
                    ))}
                </select>
            </div>

            {/* Custom Event Distance */}
            <div className='col-span-1'>
                {editableKinesisEvent.eventDistance === 'other' && (
                        <input
                        type="text"
                        className={`
                            h-full w-full p-2 placeholder:text-gray-400 focus:outline-none
                            ${hasEventDistanceTextInputChange ? 'bg-orange-100' : ''}
                        `}
                        placeholder='Enter text'
                        value={editableKinesisEvent.eventDistanceTextInput}
                        onChange={(e) => HandleEventDataEdit('eventDistanceTextInput', e.target.value)}
                    />
                )}

                {editableKinesisEvent.eventDistance !== 'other' && (
                    <div className="h-full px-2 py-2 bg-white text-gray-500 cursor-not-allowed">
                        N/A
                    </div>
                )}
            </div>

            {/* Event Training Start Date */}
            <div className='col-span-2'>
                {editableKinesisEvent.eventType === 'a-race' && 
                    <div className="relative h-full">
                        <input
                            type="date"
                            className={`
                                h-full w-full px-2 py-1 focus:outline-none text-transparent
                                select-none cursor-pointer caret-transparent
                                ${hasEventTrainingStartDateChange ? 'bg-orange-100' : ''}
                            `}
                            value={editableKinesisEvent.eventTrainingStartDate}
                            onChange={(e) => HandleEventDataEdit('eventTrainingStartDate', e.target.value)}
                            onSelect={(e) => e.preventDefault()}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                e.target.showPicker?.();
                            }}
                        />

                        <div className="absolute inset-0 flex items-center pl-2 pr-8 pointer-events-none select-none">
                            {moment(editableKinesisEvent.eventTrainingStartDate).format('MMMM, DD YYYY')}
                        </div>
                    </div>
                }

                {editableKinesisEvent.eventType !== 'a-race' && 
                    <div className="h-full px-2 py-2 bg-white text-gray-500 cursor-not-allowed">
                        N/A
                    </div>
                }
            </div>

            {/* Event Date */}
            <div className='col-span-2'>
                <div className="relative h-full">
                    <input
                        type="date"
                        className={`
                            h-full w-full px-2 py-1 focus:outline-none text-transparent
                            select-none cursor-pointer caret-transparent
                            ${hasEventDateChange ? 'bg-orange-100' : ''}
                        `}
                        value={editableKinesisEvent.eventDate}
                        onChange={(e) => HandleEventDataEdit('eventDate', e.target.value)}
                        onSelect={(e) => e.preventDefault()}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.target.showPicker?.();
                        }}
                    />

                    <div className="absolute inset-0 flex items-center pl-2 pr-8 pointer-events-none select-none">
                        {moment(editableKinesisEvent.eventDate).format('MMMM, DD YYYY')}
                    </div>
                </div>
            </div>

            {/* Deload After Event */}
            <div className='col-span-1'>
                {editableKinesisEvent.eventType === 'a-race' && 
                    <div 
                        className={
                            `h-full flex items-center justify-center cursor-pointer 
                            ${hasDeloadAfterEventChange ? 'bg-orange-100' : ''}`
                        }
                        onClick={() => HandleEventDataEdit('deloadAfterEvent', editableKinesisEvent.deloadAfterEvent === 1 ? 0 : 1)}
                    >
                        <Switch
                            checked={editableKinesisEvent.deloadAfterEvent === 1}
                            className={`
                                scale-75 relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                                ${editableKinesisEvent.deloadAfterEvent === 1 ? 'bg-orange-400' : 'bg-gray-200'}
                            `}
                        >
                            <span
                                aria-hidden="true"
                                className={`
                                    pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                    ${editableKinesisEvent.deloadAfterEvent === 1 ? 'translate-x-5' : 'translate-x-0'}
                                `}
                            />
                        </Switch>
                    </div>
                }

                {editableKinesisEvent.eventType !== 'a-race' && 
                    <div className="h-full px-2 py-2 bg-white text-gray-500 text-center cursor-not-allowed">
                        N/A
                    </div>
                }
            </div>

            {/* Delete */}
            <div className='col-span-1'>
                <div 
                    className={
                        `h-full flex items-center justify-center cursor-pointer 
                        ${hasArchivedChange ? 'bg-orange-100' : ''}`
                    }
                    onClick={() => HandleEventDataEdit('archived', editableKinesisEvent.archived === 1 ? 0 : 1)}
                >
                    <Switch
                        checked={hasArchivedChange}
                        className={`
                            scale-75 relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                            ${hasArchivedChange ? 'bg-orange-400' : 'bg-gray-200'}
                        `}
                    >
                        <span
                            aria-hidden="true"
                            className={`
                                pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                ${hasArchivedChange ? 'translate-x-5' : 'translate-x-0'}
                            `}
                        />
                    </Switch>
                </div>
            </div>
        </div>
    )
}
